import { HTTP } from '@/services/HttpServices';
import { Grouping, Channel, ChannelFilterData, ChannelCategory, ChannelPackage } from './digitalTVPackagesModel';
import { CancelToken } from 'axios';

const DIGITAL_TV_PACKAGES_PATH = 'admin/digital-tv-packages';
const GROUPINGS_PATH = `${DIGITAL_TV_PACKAGES_PATH}/groupings`

export function getGroupings(): Promise<Grouping[]> {
    return HTTP.get(`${GROUPINGS_PATH}`);
}

export async function deleteGrouping(id: number, forceDelete: boolean): Promise<void> {
    await HTTP.httpDelete(`${GROUPINGS_PATH}?id=${id}&force=${forceDelete}`);
}

export function createGrouping(grouping: Grouping): Promise<Grouping> {
    return HTTP.post(GROUPINGS_PATH, grouping);
}

export async function updateGrouping(grouping: Grouping): Promise<void> {
    await HTTP.put(`${GROUPINGS_PATH}/${grouping.id}`, grouping);
}

export async function reorderGroupings(newOrder: { id: number, displayOrder: number }[]): Promise<void> {
    await HTTP.post(`${GROUPINGS_PATH}/reorder`, { newOrder });
}

export async function getChannels(searchTerm: string, filterData: ChannelFilterData, cancelToken: CancelToken): Promise<Channel[]> {
    return HTTP.post(`${DIGITAL_TV_PACKAGES_PATH}?searchTerm=${searchTerm}`, filterData, { cancelToken });
}

export function getChannelCategories(): Promise<ChannelCategory[]> {
    return HTTP.get(`${DIGITAL_TV_PACKAGES_PATH}/categories`);
}

export function getChannelPackages(): Promise<ChannelPackage[]> {
    return HTTP.get(`${DIGITAL_TV_PACKAGES_PATH}/packages`);
}

export async function deleteChannel(id: number): Promise<void> {
    return await HTTP.httpDelete(`${DIGITAL_TV_PACKAGES_PATH}/${id}`);
}

export async function createChannel(channel: Channel): Promise<Channel> {
    return HTTP.post(`${DIGITAL_TV_PACKAGES_PATH}/channel`, channel);
}

export async function updateChannel(channel: Channel): Promise<void> {
    await HTTP.put(`${DIGITAL_TV_PACKAGES_PATH}/${channel.id}`, channel);
}